import { render, staticRenderFns } from "./FormPerfil.vue?vue&type=template&id=3ea63461"
import script from "./FormPerfil.vue?vue&type=script&lang=js"
export * from "./FormPerfil.vue?vue&type=script&lang=js"
import style0 from "./FormPerfil.vue?vue&type=style&index=0&id=3ea63461&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports